import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { isNullOrUndefined } from "../../../../../common/utils";
import useGetUserListApiCallStatus from "../../../userList/hooks/GetUserListApiCallStatus/GetUserListApiCallStatus";
import { UserListActions } from "../../../userList/model";
import useGetUserDetail from "../GetUserDetail/GetUserDetail";

function useCallApiToFetchUser(id) {
  const dispatch = useDispatch();
  const userDetail = useGetUserDetail(id);
  const { userListApiCallProgress } = useGetUserListApiCallStatus();
  const [isApiCallMadeForUser, setIsApiCallMade] = useState(false);

  function callUsersListApi() {
    dispatch(
      UserListActions.getUserList({
        page: 1,
        size: 1,
        userQuery: { id },
        sorter: { sortField: "", sortDirection: "" },
      })
    );
  }

  useEffect(() => {
    if (isNullOrUndefined(userDetail) && !userListApiCallProgress && !isApiCallMadeForUser) {
      callUsersListApi();
      setIsApiCallMade(true);
    }
  }, [userDetail, userListApiCallProgress]);

  return { isApiCallMadeForUser };
}

export default useCallApiToFetchUser;
